<template>
  <div class="overview-stu__all">
    <img
    src="../../images/check-detail.png" class="" alt="">
    <span>{{title}}</span>
  </div>
</template>

<script>
export default {
  props: ['title'],
};
</script>

<style scoped lang="scss">
 .overview-stu__all{
    width: 116px;
    height: 36px;
    border-radius: 4px;
    border: 1px solid #1989FA;
    line-height:36px ;
    position: relative;
    padding-left: 35px;
    box-sizing: border-box;
    cursor: pointer;
    span{
      font-size: 16px;
      font-weight: 400;
      color: #1989FA;
    }
    img{
      position: absolute;
      width: 16px;
      height: 16px;
      top: 9px;
      left: 17px;
    }
  }
</style>
